import {
  Input,
  OnInit,
  Inject,
  Component,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';
import summaryItemHtml from './summary-item.html';

/**
 * Order Summary Item (section)
 *
 * Displayed on summary pages and panels
 * detailing order and pricing totals.
 */
@Component({
  selector: 'gwSummaryItem',
  template: summaryItemHtml,
})
export class SummaryItemComponent implements OnInit {
  public cart;
  public state: any = {};

  @Input() orderItems;
  @Input() index: string;
  @Input() expanded: boolean;
  @Input() travelerId: string;

  constructor(
    @Inject(CartService) private cartService: CartService,
  ) {}

  async ngOnInit() {
    this.state.open = this.expanded || false;
  }

  subtotal(shipping: number, options, product): number {
    return this.cartService.getSubtotal(shipping, options, product.addons);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/summary/summary-item/summary-item.component.ts